import { ComponentPropsWithoutRef } from "react";
// components
import IconButton from "components/icon-button";
import ConfirmModal from "components/confirm-modal";
import { ReactComponent as OutlineTrash16 } from "assets/svg/outline-trash-16.svg";
// hooks
import useToggleModal from "hooks/useToggleModal";
// constants
import messages from "messages";
// styles
import styles from "./styles.module.scss";

type Props = {
  onDelete: () => void;
  isSection?: boolean;
} & ComponentPropsWithoutRef<typeof IconButton>;

const Delete = ({ onDelete, isSection, ...rest }: Props) => {
  const { open, close, show } = useToggleModal(false);
  return (
    <>
      <IconButton onClick={() => open()} {...rest} className={styles["delete"]}>
        <OutlineTrash16 />
      </IconButton>
      <ConfirmModal
        children={messages.ifYouDeleteAddendum}
        show={show}
        onCancel={close}
        onConfirm={onDelete}
      />
    </>
  );
};

export default Delete;
